















































import { Vue, Component } from 'vue-property-decorator';
import Table from '@/components/Table/Index.vue';
import BetData from '@/data/BetData';

@Component({
  components: {
    Table,
  },
})
export default class UserOnlineView extends Vue {
  TableHead = BetData.TableHead;
}
